var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"philosophy"}},[_c('NavBar'),_c('Banner'),_c('Main'),_c('Footer',{scopedSlots:_vm._u([{key:"sns-share",fn:function(){return [_c('SnsShare')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }